/** 320 ms, 1,2 s: duration between the call to QZ Tray and its answer. */
export const formatDuration = (ms?: number): string => {
  if (ms === undefined) {
    return '-';
  }
  if (ms < 1000) {
    return `${ms} ms`;
  }
  return `${(ms / 1000).toFixed(1).replace('.', ',')} s`;
};
